// extracted by mini-css-extract-plugin
export var actionButton = "_dx-t";
export var buttonContainer = "_dx-0";
export var buttonContainer2 = "_dx-1";
export var buttonSection = "_dx-2";
export var details = "_dx-3";
export var dropdownItem = "_dx-5";
export var dropdownItemsContainer = "_dx-4";
export var fileInput = "_dx-r";
export var headerButton = "_dx-6";
export var icon = "_dx-7";
export var input = "_dx-8";
export var macroListItem = "_dx-9";
export var mainContent = "_dx-a";
export var microText = "_dx-b";
export var modal = "_dx-w";
export var optionsButton = "_dx-c";
export var paperclip = "_dx-s";
export var pillContent = "_dx-d";
export var preview = "_dx-e";
export var preview2 = "_dx-f";
export var quillEditor = "_dx-q";
export var selectedMacro = "_dx-g";
export var sidebar = "_dx-h";
export var sidebarHeader = "_dx-j";
export var sidebarList = "_dx-i";
export var sidebarListItem = "_dx-k";
export var sidebarSearch = "_dx-l";
export var snoozeDurationWrapper = "_dx-v";
export var statusPillContainer = "_dx-m";
export var tagsContainer = "_dx-n";
export var unselectedMacro = "_dx-o";
export var variable = "_dx-u";
export var wrapper = "_dx-p";